<template>
  <tr class="cursor-pointer">
    <td
      class="border border-gray-900 px-4 py-2"
      @click="onNFTClick(contract, id)"
    >
      <img
        v-bind:src="image"
        alt="NFT"
        class="object-contain h-24 m-0 m-auto"
        style
      />
    </td>
    <td
      class="border border-gray-900 px-4 py-2"
      @click="onNFTClick(contract, id)"
    >
      <span class="hidden md:inline-block"
        >{{ name.slice(0, 25) }}.. ( #{{ id }})</span
      >
      <span class="md:hidden">#{{ id }}</span>
    </td>
    <td class="border border-gray-900 px-4 py-2" v-if="canMine">
      <div class="flex justify-center space-x-4 items-center">
        <div>{{ canMine }}</div>
        <div class="tooltip">
          <span class="tooltiptext">Toggle to mine with it.</span>
          <input type="checkbox" id="mine" :data-id="id" />
        </div>
      </div>
    </td>
    <td class="border border-gray-900 px-4 py-2" v-if="!canMine">
      In
      <countdown :end-time="(lastTimeMined + 60 * 60 * 24) * 1000">
        <template v-slot:process="mine">
          <span>
            {{ `${mine.timeObj.h}:${mine.timeObj.m}:${mine.timeObj.s}` }}
          </span>
        </template>
        <template v-slot:finish>
          <span>Done!</span>
        </template>
      </countdown>
    </td>
    <td class="border border-gray-900 px-4 py-2">
      <span v-if="isVnftAlive">
        <vac :end-time="timeUntilStarving * 1000">
          <span slot="process" slot-scope="{ timeObj }">
            {{ `${timeObj.d} days and ${timeObj.h}:${timeObj.m}:${timeObj.s}` }}
          </span>
          <span slot="finish">Dead!</span>
        </vac>
      </span>

      <span v-else>Dead</span>
    </td>
    <td class="border border-gray-900 px-4 py-2">
      <div
        class="w-full md:w-full px-3 mb-6 md:mb-0 m-0 m-auto flex -mx-2 items-center"
      >
        <div class="relative px-2 w-full">
          <select
            class="text-center block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500 feed-gem"
            id="grid-state"
            :data-nftid="id"
          >
            <option value="null">Don't feed</option>
            <option value="1">Gem1: 2d tod, 100 points, 5Muse</option>
            <option value="2">Gem2: 1.5d tod, 190 points, 6Muse</option>
            <option value="3">Gem3: 4d tod, 1 point, 20Muse</option>
            <option value="4">Gem4: 1d tod, 444 point, 13Muse</option>
            <option value="5">Gem5: IMMORTABLE, 4500 points, 0.1Muse</option>
            <option value="6">Gem6: 5d tod, 3100 point, 100Muse</option>
          </select>
          <div
            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
          >
            <svg
              class="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
              />
            </svg>
          </div>
        </div>
        <div class="px-2 tooltip">
          <span class="tooltiptext" v-if="!isCareTaker">Add as caretaker</span>
          <span class="tooltiptext" v-else>Remove as care taker</span>
          <input
            type="checkbox"
            v-model="isCareTaker"
            @click="toggleCareTaker(id)"
          />
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
const axios = require("axios").default;
import Address from "@/components/Address.vue";

export default {
  name: "NFTTools",
  components: { Address },
  props: {
    contract: String,
    id: String,
    onClicked: Function,
  },
  data: function () {
    return {
      name: "",
      image: "",
      addressOrigin: "",
      idOrigin: "",
      isVnftAlive: false,
      timeUntilStarving: 0,
      timeVnftBorn: 0,
      expectedReward: 0,
      fatalityReward: 0,
      score: 0,
      level: 0,
      isOwner: false,
      lastTimeMined: 0,
      owner: "",
      isForSale: false,
      loader: null,
      isCareTaker: false,
    };
  },
  methods: {
    onNFTClick: function (contract, id) {
      this.$router.push({ name: "vNFT", params: { id: id } });
    },
    fetchInfos: async function () {
      if (this.$store.state.web3 == null) {
        return;
      }
      let infos = await this.$store.state.vNFTContract.methods
        .getVnftInfo(this.id)
        .call();
      // console.log(infos);

      this.expectedReward = parseInt(infos._expectedReward);

      this.timeUntilStarving = parseInt(infos._timeUntilStarving);
      this.timeVnftBorn = parseInt(infos._timeVnftBorn);
      this.lastTimeMined = parseInt(infos._lastTimeMined);

      this.score = parseInt(infos._score);
      this.level = parseInt(infos._level);
      this.owner = infos._owner;
      this.isVnftAlive = infos._isAlive;
      this.isOwner =
        this.owner.toLowerCase() == this.$store.state.account.toLowerCase();
      this.fatalityReward = parseInt(infos._fatalityReward);

      const img = await axios.get(
        `https://gallery.verynifty.io/api/${this.id}`
      );
      this.image = img.data.image_data;

      const forSale = await axios.get(
        `https://gallery.verynifty.io/api/opensea/${this.id}`
      );
      this.isForSale = forSale.data == this.id;

      const { data } = await axios(
        `https://gallery.verynifty.io/api/name/${this.id}`
      );
      this.name = data;
    },
    checkCanMine: function () {
      this.lastTimeMined + 60 * 60 * 24 >= new Date().getTime();
    },
    toggleCareTaker: async function (id) {
      if (this.isCareTaker) {
        this.removeCareTaker(id);
      } else if (!this.isCareTaker) {
        this.addCareTaker(id);
      }
    },
    addCareTaker: async function (id) {
      try {
        this.loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          // onCancel: this.onCancel,
        });
        let addcaretaker = await this.$store.state.vNFTContract.methods
          .addCareTaker(id, this.$store.state.contracts.MultiVnft)
          .send({
            from: this.$store.state.account,
          });

        this.loader.hide();
        this.careTaker = true;
        this.$notify({
          group: "foo",
          title: "Success",
          text: `You added MultiVnft contract as a care taker for #${id}.`,
          type: "success",
        });
      } catch (e) {
        this.loader.hide();
        this.$notify({
          group: "foo",
          title: "Error",
          text: `There was an error with the tx`,
          type: "error",
        });
      }
    },
    removeCareTaker: async function (id) {
      try {
        this.loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          // onCancel: this.onCancel,
        });
        let removecaretaker = await this.$store.state.vNFTContract.methods
          .clearCareTaker(id)
          .send({
            from: this.$store.state.account,
          });

        this.loader.hide();
        this.careTaker = false;

        this.$notify({
          group: "foo",
          title: "Success",
          text: `You cleared all care takers.`,
          type: "success",
        });
      } catch (e) {
        this.loader.hide();
        this.$notify({
          group: "foo",
          title: "Error",
          text: `There was an error with the tx`,
          type: "error",
        });
      }
    },
    checkCareTaker: async function () {
      const careTaker = await this.$store.state.vNFTContract.methods
        .careTaker(this.id, this.$store.state.account)
        .call();

      this.isCareTaker =
        careTaker == this.$store.state.contracts.MultiVnft ? true : false;
    },
  },
  beforeMount: function () {
    this.fetchInfos();
  },
  mounted: function () {
    // setTimeout(() => {
    //   if (this.position <= 50) {
    //     alert(this.position);
    //   }
    // }, 5000);
    // return proper image
    // this.name =generateName(this.id)
    this.checkCareTaker();
  },
  watch: {
    isConnected: function () {
      this.fetchInfos();
    },
  },
  computed: {
    isConnected: function () {
      return this.$store.state.web3 != null;
    },
    canMine: function () {
      let nextMining = this.lastTimeMined + 60 * 60 * 24;
      let currentTime = Math.floor(Date.now() / 1000);
      return nextMining < currentTime;
    },
  },
};
</script>
<style scoped>
/* Tooltip container */
.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black; /* If you want dots under the hoverable text */
}

/* Tooltip text */
.tooltip .tooltiptext {
  font-size: 12px;
  top: -5px;
  right: 105%;
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>